import React from 'react';
import { Link } from 'react-router-dom';
import projMan from '../../images/projSub.jpg';
import blog4 from '../../images/blog-details/comments-author/img-2.jpg';
import blog5 from '../../images/blog-details/comments-author/img-3.jpg';
import blog6 from '../../images/blog-details/author.jpg';
import blogs from '../../api/blogs';
import { useParams } from 'react-router-dom';
import Secretary from '../../images/studentReq.jpg';

const Counsellor = (props) => {
    const { slug } = useParams();
    const BlogDetails = blogs.find(item => item.slug === slug);

    const submitHandler = (e) => {
        e.preventDefault();
    };

    return (
        <section className="blog-single-section section-padding">
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-9 col-12 ${props.blRight}`}>
                        <div className="blog-content">
                            <div className="tag-share">
                                <div className="post format-standard-image">
                                    <div className="entry-media">
                                        <img src={Secretary} alt="" />
                                    </div>
                                    <ul className="entry-meta">
                                        <li><Link to="">FFSD GROUP</Link></li>
                                        <li><Link to="">Location: Lagos</Link></li>
                                        <li><Link to="">Employment Type: Full-Time</Link></li>
                                    </ul>
                                    
                                    <h2>Job Title: Education Counsellor (Student Recruitment)</h2>
                                    
                                    <h3>About the Organization</h3>
                                    <p>
                                        FFSD Education is a dynamic, goal-driven international education recruitment agency with a strong reputation for delivering high-quality, student centred support. We partner with reputable institutions to guide students toward successful academic and career outcomes. As part of our continued growth, we are seeking a motivated and results-oriented Education Counsellor to join our team.
                                    </p>
                                    
                                    <h3>Key Responsibilities</h3>
                                    <p>
                                        - Strategically generate, nurture, and convert prospective student leads across the recruitment and marketing funnel to meet or exceed annual enrolment targets.<br />
                                        - Manage and respond promptly to inbound enquiries from multiple channels, including education fairs, events, digital campaigns, and social media platforms.<br />
                                        - Proactively engage prospective students through phone calls, emails, video conferencing, and social platforms to promote FFSD's services and partner institutions.<br />
                                        - Provide professional counselling to prospective students on suitable study options, including courses, institutions, and destinations.<br />
                                        - Guide applicants through the full application lifecycle, including admissions, visa processing, and pre-departure preparation.<br />
                                        - Prepare, process, and submit applications to partner institutions, follow up on offers, and ensure timely enrolment.<br />
                                        - Ensure all applicant documentation is complete, accurate, and compliant with institutional and visa requirements.<br />
                                        - Support business development, marketing initiatives, and promotional activities.<br />
                                        - Participate in, organise, and represent FFSD at education fairs, school visits, and outreach events.<br />
                                        - Monitor competitor activity, market trends, and updates related to FFSD products and partner institutions.<br />
                                        - Uphold high standards of professionalism, accountability, and ethical conduct.
                                    </p>

                                    <h3>Requirements</h3>
                                    <p>
                                        - Bachelor's degree or equivalent qualification in any discipline.<br />
                                        - 1–3 years of relevant professional experience, with a minimum of 2 years in sales, client engagement, recruitment, or commercial role.<br />
                                        - Demonstrated ability to meet or exceed sales or student recruitment targets.<br />
                                        - Strong social selling and networking capabilities.<br />
                                        - Excellent written and verbal communication skills in English.<br />
                                        - Confidence in engaging clients and stakeholders via phone, video calls, and written correspondence.<br />
                                        - Proactive and organised approach to managing applicants and institutional partners.<br />
                                        - Proven ability to build, manage, and maintain strong client relationships.<br />
                                        - Ability to work independently with minimal supervision.<br />
                                        - Previous experience as a student or education counsellor is an added advantage.
                                    </p>

                                    <h3>Personal Attributes</h3>
                                    <p>
                                        - Passionate about working with people and supporting student success.<br />
                                        - Results-oriented, resilient, and solution-focused.<br />
                                        - Ambitious and thrives in a fast-paced, target-driven environment.<br />
                                        - Strong interpersonal, communication, and relationship-building skills.<br />
                                        - Self-motivated, competitive, and comfortable working with KPIs.
                                    </p>

                                    <h3>How to Apply</h3>
                                    <p>
                                        If you meet the qualifications and are excited about this opportunity, please submit your CV, degree certificate, and a cover letter to <a href="mailto:careers@ffsdgroup.com">careers@ffsdgroup.com</a> with the job title and reference number "Education Counsellor - 20023" in the subject line.
                                    </p>

                                    <h3>Compensation</h3>
                                    <p>
                                        We offer a competitive salary package commensurate with experience, plus performance-based incentives.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Counsellor;